import { render, staticRenderFns } from "./SearchRegister.vue?vue&type=template&id=436c7cc4"
import script from "./SearchRegister.vue?vue&type=script&lang=js"
export * from "./SearchRegister.vue?vue&type=script&lang=js"
import style0 from "./SearchRegister.vue?vue&type=style&index=0&id=436c7cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports